// convert a key-value pair to a CML attribute string, skipping falsy/missing values via `predicate`
export const getCmlAttribute = ([key, value]: [string, string | undefined], predicate = true) => {
  return predicate ? [`${key}="${value}"`] : [];
};
